import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { AudioPlayerProvider } from './components/AudioPlayerContext'
import GlobalStyle from './components/GlobalStyle'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <AudioPlayerProvider>
      <App />
    </AudioPlayerProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
